<template>
  <div class="login">
    <div class="top">
      <img class="bgImg" :src="bgImg" alt />
    </div>
    <div class="content">
      <div class="detail">
        <div class="name">
          {{ $getItem("config") != undefined ? $getItem("config").name : "" }}
        </div>
        <KImg class="pageLoginImgShadow" :src="lgImg" />
        <Warning message="请使用接收电子券手机号，以免影响电子券领取。" />
        <div class="formData">
          <div class="form">
            <van-field
              class="pageInput"
              v-model="phone"
              clearable
              :border="false"
              type="number"
              maxlength="11"
              placeholder="请输入手机号码"
              @clear="handleClearMobile"
              @input="checkphone"
            />
            <van-field
              class="pageInput"
              v-model="code"
              maxlength="6"
              placeholder="验证码"
              @clear="handleClearCode"
            >
              <template #button>
                <KBtn
                  size="small"
                  :title="codeText"
                  :disabled="disabled"
                  @click="getCode"
                  color="var(--depYelColor)"
                />
              </template>
            </van-field>
            <!-- <div class="agreement">
              <van-checkbox
                v-if="agreementType && agreementType > 0"
                v-model="checked"
                shape="square"
                icon-size="14px"
                label-disabled
                >已阅读并同意
                <div class="agreement-content" v-if="agreementType === 1">
                  <span class="text" @click="zsrbAgreementClickHandle(1)"
                    >《中国人保财险服务协议》、</span
                  ><span class="text" @click="zsrbAgreementClickHandle(2)"
                    >《中国人民财产保险股份有限公司隐私政策》、</span
                  ><span class="text" @click="zsrbAgreementClickHandle(3)"
                    >《中国人民财产保险股份有限公司儿童个人信息保护规则》</span
                  >
                </div>
              </van-checkbox>
            </div> -->
            <KBtn
              size="big"
              title="绑定手机号"
              color="var(--depYelColor)"
              @click="handleConfirm"
            />
          </div>
        </div>
      </div>
    </div>
    <ZsrbInsurance1 ref="zsrbInsurance1"></ZsrbInsurance1>
    <ZsrbInsurance2 ref="zsrbInsurance2"></ZsrbInsurance2>
    <ZsrbInsurance3 ref="zsrbInsurance3"></ZsrbInsurance3>
  </div>
</template>

<script>
import Warning from "../common/Warning";
import { userRegister, getCode } from "api/user";
import ZsrbInsurance1 from "../agreement/zsrb/insurance1.vue";
import ZsrbInsurance2 from "../agreement/zsrb/insurance2.vue";
import ZsrbInsurance3 from "../agreement/zsrb/insurance3.vue";

export default {
  components: {
    Warning,
    ZsrbInsurance1,
    ZsrbInsurance2,
    ZsrbInsurance3,
  },
  data() {
    return {
      bgImg: require("assets/u2.png"),
      lgImg: "",
      tel: "",
      url: "",
      mobile: null,
      code: "",
      phone: null,
      disabled: false,
      codeText: "获取验证码",
      tels: "",
      urls: "",
      isSend: false,
      checked: true,
      agreementType: 0,
    };
  },
  created() {
    if (
      (this.$getItem("config") != undefined) &
      (this.$getItem("config") != null) &
      (this.$getItem("config") != "")
    ) {
      this.lgImg = require("@/assets/" + this.$getItem("config").logo + ".png");
    }
  },
  mounted() {
    $(".footer").hide();
  },
  destroyed() {
    $(".footer").show();
  },
  methods: {
    checkphone(val) {
      if (this.$getItem("phone") != undefined) {
        if (val != this.$getItem("phone")) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    },
    getCode() {
      if (this.formatPhone() && !this.disabled) {
        this.disabled = true; // 防止请求网速慢时的多次点击
        getCode(this.phone, 3)
          .then((res) => {
            if (res.status === 200) {
              this.isSend = true;
              this.downTime();
              this.$success("短信验证码已发送");
            } else {
              this.disabled = false;
              this.$error(res.message);
            }
            if (res.data) {
              this.agreementType = res.data;
            }
          })
          .catch((err) => {
            this.disabled = false;
          });
      }
    },
    handleConfirm() {
      // if (!this.checked) {
      //   this.$error("请先阅读并勾选同意协议！");
      //   return false;
      // }
      if (this.formatPhone()) {
        if (!this.isSend) {
          this.$error("请点击获取短信验证码");
          return false;
        }
        if (!this.code) {
          this.$error("请输入验证码");
          return false;
        }
        if (this.code.length < 6) {
          this.$error("请输入6位的验证码");
          return false;
        }
        this.$loading("绑定中");
        userRegister(this.phone, this.code, 0).then((res) => {
          this.$clear();
          if (res.status === 200) {
            this.$setItem("isRegister", true);
            this.$successSync("绑定成功", () => {
              this.$replace({
                path: "/coupons",
              });
            });
          } else {
            this.$error(res.message);
          }
        });
      }
    },
    formatPhone() {
      if (!this.phone) {
        this.$error("手机号码不能为空");
        return false;
      }
      if (!this.$regPhone(this.phone)) {
        this.$error("手机号码格式错误");
        return false;
      }
      return true;
    },
    downTime() {
      let time = 59;
      let interval = setInterval(() => {
        if (time > 0) {
          let changeTime = time--;
          if (time < 10 && time > 0) {
            changeTime = "0" + time;
          }
          this.codeText = changeTime + "秒后再获取";
        } else {
          clearInterval(interval);
          this.disabled = false;
          this.codeText = "获取验证码";
        }
      }, 1000);
    },
    handleClearMobile() {
      this.phone = "";
    },
    handleClearCode() {
      this.code = "";
    },
    zsrbAgreementClickHandle(index) {
      let object = "zsrbInsurance" + index;
      this.$refs[object].show = true;
    },
  },
};
</script>

<style scoped lang="less">
.login {
  .top {
    overflow: hidden;
    height: 200px;
    background: linear-gradient(
      180deg,
      rgba(255, 51, 0, 1) 0%,
      var(--bgColor) 100%
    );
    .bgImg {
      width: 74%;
      height: 86px;
      margin: 6px auto;
      display: block;
    }
  }
  .content {
    margin-top: -135px;
    position: relative;
    .detail {
      position: absolute;
      top: 0;
      left: 20px;
      right: 20px;
      .kimg {
        position: absolute;
        top: -18px;
        left: 0px;
        width: 83px;
        height: 83px;
        border-radius: 50%;
      }
      .name {
        height: 48px;
        line-height: 50px;
        font-weight: var(--defaultFontWeight);
        font-size: 18px;
        color: var(--redColor);
        text-align: right;
        padding-right: 20px;
        border-radius: 48px;
        background: #fff;
        box-shadow: 0px 2px 8px 1px var(--redColor);
      }
      .warning {
        margin-top: 38px;
      }
      .formData {
        margin-top: 25px;
        .form {
          /deep/.van-cell {
            margin-top: 18px;
            height: 50px;
            line-height: 31px;
            font-size: var(--titleFont);
            /deep/.van-field__control {
              color: var(--assistantColor);
            }
          }
          /deep/.van-field__button {
            margin-top: -5px;
          }
          /deep/.van-button {
            width: 100%;
            height: 50px;
            margin-top: 15px;
            font-weight: var(--defaultFontWeight);
            border-radius: var(--defaultRadius);
          }
          /deep/.van-button--small {
            width: 90px;
            padding: 0px 5px;
            height: 27px;
            border-radius: var(--defaultRadius);
            box-sizing: border-box;
            margin-top: -3px;
            display: inline-block;
          }
        }
      }
      .unLogin {
        margin-top: 35px;
        text-align: center;
        color: #999;
        font-size: var(--middleFont);
      }
      .agreement {
        margin-top: 15px;
        font-size: var(--smallFont);
        /deep/.van-checkbox__label {
          line-height: normal;
          color: #999;
        }
        .agreement-content {
          display: inline;
          .text {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
